import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ScheduleModalHeader from 'components/ScheduleModal/Header/ScheduleModalHeader';
import ScheduleInfo from 'containers/ScheduleModal/ScheduleInfoContainer';
import ScheduleSearchCont from 'containers/ScheduleSearch/ScheduleSearchContainer';
import OneTimeMeetingBuilder from 'containers/OneTimeMeetingBuilder/OneTimeMeetingBuilderContainer';
import classes from './ScheduleModal.module.scss';
import clsx from 'clsx';

const callLocationGenerator = () => (
  <FormattedMessage id="components.schedule.search.title" defaultMessage="Where should the participants call?" />
);

export const ScheduleModal = (props) => (
  <React.Fragment>
    <div className={classes.container} data-testid="scheduleModal">
      <ScheduleModalHeader addModal={props.addModal} editingSchedule={props.editingSchedule} />

      <div className={clsx(classes.body, props.scheduleOneTime ? classes.oneTimeMeetingForm : '')}>
        {props.scheduleOneTime && <OneTimeMeetingBuilder schedule />}

        {!props.scheduleOneTime && (
          <React.Fragment>
            <section>
              <div className={classes.searchHeader}>{callLocationGenerator()}</div>

              <ScheduleSearchCont contact={props.contact} />

              {props.missingContact && (
                <span className={classes.missingMeeting}>
                  <FormattedMessage
                    id="components.schedule.search.missing"
                    defaultMessage="The original meeting has been deleted. Please choose another."
                  />
                </span>
              )}
            </section>

            {props.contact.name && <ScheduleInfo />}
          </React.Fragment>
        )}
      </div>
    </div>
  </React.Fragment>
);

ScheduleModal.propTypes = {
  contact: PT.object,
  isVSTO: PT.bool,
  editingSchedule: PT.bool,
  missingContact: PT.bool,
  addModal: PT.bool,
  scheduleOneTime: PT.bool
};

export default ScheduleModal;
